import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { ErrorInterceptor } from '../shared/interceptors/error.interceptor';
import { ClassificationComponent } from './components/classification/classification.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../shared/shared.module';
import { APP_BASE_HREF } from '@angular/common';
import { JwtModule } from '@auth0/angular-jwt';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LayoutModule } from '@angular/cdk/layout';
import { ClassificationModule } from './classification.module';
import { HotkeyModule } from 'angular2-hotkeys';

@NgModule({
  imports: [
    SharedModule,
    ClassificationModule,
    LayoutModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          const info = localStorage.getItem('token');
          return info ? JSON.parse(localStorage.getItem('token')).access_token : null;
        },
        skipWhenExpired: false,
        allowedDomains: [
          'localhost:59944',
          'localhost:56344',
          'localhost:7071',
          'api-contador.nibo.com.br',
          'api-iu-contador.nibo.com.br',
          'brnibo.blob.core.windows.net',
          'arquivos.nibo.com.br',
          'passport.nibo.com.br',
          'test-files.nibo.com.br',
        ],
        disallowedRoutes: [/test-files.nibo.com.br\/download\/.*/, /arquivos.nibo.com.br\/download\/.*/],
      },
    }),
    HotkeyModule.forRoot({
      cheatSheetCloseEsc: true,
    }),
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  entryComponents: [ClassificationComponent],
})
export class ClassificationWebComponentModule implements DoBootstrap {
  constructor(private _injector: Injector) {}

  ngDoBootstrap(): void {
    if (!customElements.get('file-classification')) {
      customElements.define('file-classification', createCustomElement(ClassificationComponent, { injector: this._injector }));
    }
  }
}
